import $ from 'jquery';

export default class QuantityControls {
    constructor(theme, element) {
        this.theme = theme;
        this.element = element;
        this.$element = $(this.element);
        this.$element.find('.quantity-controls button.qty-plus').off().on('click', function (e) {
            e.preventDefault();
            var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
            const val = parseInt(qtyInput.val().toString(), 10);
            qtyInput.val(val + 1);
        });

        this.$element.find('.quantity-controls button.qty-minus').off().on('click', function (e) {
            e.preventDefault();
            var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
            const val = parseInt(qtyInput.val().toString(), 10);
            var newQty = (val - 1 < 1) ? 1 : val - 1;
            qtyInput.val(newQty);
        });
    }
}1